



import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class RegimeFixedChart extends Vue {

	public get series() {
		return this.regime;
	}

	public get lables() {
		return [`Да - ${(this.series[0] as number).toLocaleString()}`,
		`Нет - ${(this.series[1] as number).toLocaleString()}`];
	}

	public get chartTitle() {
		return this.$store.getters['russia/getRegimeFixed'].title;
	}

	public options = {
		chart: {
			type: 'donut',
			toolbar: {
				show: false,
			},
			zoom: {
				enabled: false,
			},
		},
		labels: this.lables,
		legend: {
			fontSize: '18px',
			position: 'bottom',
			horizontalAlign: 'left',
		},
		colors: ['#1565c0', '#c62828'],
		title: {
			text: this.chartTitle,
			align: 'center',
			style: {
				fontWeight: 'normal',
				fontSize: '20px',
			},
		},
		dataLabels: {
			enabled: true,
		},
		plotOptions: {
			pie: {
				donut: {
					labels: {
						show: true,
						name: {
							show: true,
						},
						total: {
							show: true,
							showAlways: true,
							label: 'Всего',
							formatter: (val) => {
								return this.formatDigit(this.series[0] + this.series[1]);
							},
						},
					},
				},
			},
		},
	};

	public get regime(): number[] {
		return this.$store.getters['russia/getRegimeFixed'].values;
	}

	@Watch('series', { deep: true })
	public onSeriaesChange(val) {
		(this.$refs.regimeChart as any).updateOptions({
			labels: this.lables,
			title: {
				text: this.chartTitle,
			},
		});
	}
	public mounted() {
		this.$nextTick(() => {
			if ((this.$refs.regimeChart as any)) {
				setTimeout(() => {
					this.$nextTick(() => (this.$refs.regimeChart as any).updateSeries(this.series));
				}, 300);
			}
		});
	}

	private formatDigit(val: number) {
		return `${val.toLocaleString()}`;
	}

}
